var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template__message mb15"},[_c('div',{staticClass:"template__label"},[_vm._v(_vm._s(_vm.$t('dashboard.label.message')))]),_c('div',{staticClass:"message__input input-focus-within"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }